import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import SDElementsCredentialsForm from "./SDElementsCredentialsForm";
import SDElementsConfigListing from "./SDElementsConfigListing";

export default function SDElementsPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={SDElementsCredentialsForm}
      PullConfigListingView={SDElementsConfigListing}
      RunOnDemandButtonText={"Sync tool images"}
    />
  );
}
